import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

const footerLinks = {
  navigation: [
    { label: '首页', path: '/' },
    { label: '全部分类', path: '/category/all' },
    { label: '关于我们', path: '/about' },
  ],
  categories: categories.filter((c) => c.slug !== 'all').slice(0, 6),
  contact: [
    { label: '邮箱：contact@hanmanzhijia.com', path: '' },
    { label: '微信公众号：韩漫之家', path: '' },
    { label: '微博：@韩漫之家官方', path: '' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 font-heading text-lg font-bold text-background-50 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-open-line text-background-50"></i>
              </div>
              韩漫之家
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              专业的韩漫在线阅读平台，采用智能加载技术，提供流畅舒适的下拉式阅读体验。海量韩漫资源，每日更新。
            </p>
          </div>

          <div>
            <h4 className="text-background-50 font-semibold text-sm mb-4">
              <a href="#footer-nav" className="text-background-50 no-underline">快速导航</a>
            </h4>
            <ul className="flex flex-col gap-2.5">
              {footerLinks.navigation.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-sm text-background-400 hover:text-background-50 transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-background-50 font-semibold text-sm mb-4">
              <a href="#footer-categories" className="text-background-50 no-underline">热门分类</a>
            </h4>
            <ul className="flex flex-col gap-2.5">
              {footerLinks.categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-background-50 transition-colors duration-200"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-background-50 font-semibold text-sm mb-4">
              <a href="#footer-contact" className="text-background-50 no-underline">联系我们</a>
            </h4>
            <ul className="flex flex-col gap-2.5">
              {footerLinks.contact.map((item) => (
                <li key={item.label} className="text-sm text-background-400">
                  {item.path ? (
                    <Link to={item.path} className="hover:text-background-50 transition-colors duration-200">
                      {item.label}
                    </Link>
                  ) : (
                    item.label
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2026 韩漫之家. All rights reserved. 本站所有漫画资源仅供学习交流使用。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200" rel="nofollow">
              服务条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}